import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Paper, TextField, Button, TableFooter } from '@mui/material';
import isGHMC, { formatDateTimeWithoutSec, getCurrentDateTime, getStartOfCurrentDate } from '../../../Common/helper/helpar';
import CreatableSelect from 'react-select/creatable';
import { AllVehicleDetails } from '../../../Apis/vehicleApi';
import { AllDriverDetails } from '../../../Apis/driverApi';
import axiosInstance from '../../../../Hooks/axoisInstance';
import ExcelJS from "exceljs";
import { AllTertiaryTripReport } from '../../../Apis/userCreationApi';
import { AllVehicleTypeDetails } from '../../../Apis/vehicleApi';
import { AllOwnerTypeDetails } from '../../../Apis/ownerTypeApi';

const TertiaryTripDetailsReport = () => {
  const [rows, setRows] = useState([]);
  const [vehicleId, setVehicleId] = useState('');
  const [driverId, setDriverId] = useState('');
  const [optionsVehicleValues, setOptionVehicleValues] = useState([]);
  const [optsVehicle, setOptsVehicle] = useState(optionsVehicleValues);
  const [optionsDrivervalues, setOptionDriverValues] = useState([]);
  const [optsDriver, setOptsDriver] = useState(optionsDrivervalues);
  const [orderDirection, setOrderDirection] = useState("asc");
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [sortedData, setSortedData] = useState([]);
  const [page, setPage] = useState(0);
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [selectedVehilceNo, setSelectedVehicleNo] = useState([]);
  const [vehicleNo, setVehicleNo] = useState([]);
  const [driverName, setDriverName] = useState([]);
  const [selectedDriverName, setSelectedDriverName] = useState([]);
  const [VehicleNumberDetails, setVehicleNumberDetails] = useState([]);
  const [driverNameDetails, setDriverNameDetails] = useState([]);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [optionsValues, setOptionsValues] = useState([]);
  const [vehicleTypeOptionsValues, setVehicleTypeOptionsValues] = useState([]);
  const [optionsLoadingValues, setOptionLoadingValues] = useState([]);
  const [selectedOwnerType, setSelectedOwnerType] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [selectedVehicleType, setSelectedVehicleType] = useState([]);
  const currentDateTime = getCurrentDateTime();
  const currentDateWithStartTime = getStartOfCurrentDate();
  const [fromDate, setFromDate] = useState(currentDateWithStartTime);
  const [toDate, setToDate] = useState(currentDateTime);
  const isProd = isGHMC();

  // Fetch data from API
  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };
    console.log(selectedOwnerType, 'selectedowner')
    fetchOwnerTypeData();
  }, [selectedOwnerType]);

  useEffect(() => {
    const fetchVehicleTypeData = async () => {
      try {
        const vehicleTypeData = await AllVehicleTypeDetails();
        setVehicleTypeDetails(vehicleTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleTypeData();
  }, []);

  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedOwnerType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedOwnerType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedOwnerType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };
  const handleVehicleTypeChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedVehicleType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedVehicleType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };


  const fetchData = async (filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    try {
      const data = await AllTertiaryTripReport(queryParams)

      // Format data according to the new API response
      const formattedData = data.map((item, index) => ({
        sno: index + 1,
        vehicleNumber: item.vehicleNumber,
        vehicleType: item.vehicleType,
        vehicleCapacity: item.vehicleCapacityName,
        ownerType: item.ownerTypeName,
        shift: item.shift,
        driverName: item.driverName,
        forwardStartLocation: item.forwardStartLocation,
        forwardEndLocation: item.forwardEndLocation,
        forwardStartTime: item.forwardStartTime,
        forwardEndTime: item.forwardEndTime,
        returnStartLocation: item.returnStartLocation,
        returnEndLocation: item.returnEndLocation,
        returnStartTime: item.returnStartTime,
        returnEndTime: item.returnEndTime,
        tripNumber: item.tripNumber,
        forwardTripDistanceMeters: item.forwardTripDistanceMeters,
        returnTripDistanceMeters: item.returnTripDistanceMeters,
        totalDistanceMeters: item.totalDistanceMeters,
        travelDurationMinutes: item.travelDurationMinutes,
        driverId: item.driverId,
      }));

      setRows(formattedData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    setOptionsValues(ownerTypeDetails
      .filter((ownerType) => ownerType.isActive)
      .map(ownerType => ({
        value: ownerType.ownerTypeId,
        label: ownerType.ownerTypeName,
      })));
  }, [ownerTypeDetails]);

  useEffect(() => {
    setVehicleTypeOptionsValues(vehicleTypeDetails.map(vehicleType => ({
      value: vehicleType.vehicleTypeId,
      label: vehicleType.vehicleTypeName,
    })));
  }, [vehicleTypeDetails]);

  const handleDriverNameChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedDriverName(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedDriverName(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedDriverName(null); // Ensure selectedOwnerType is cleared
      }
    }
  };
  // Filter rows based on date range
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const handleFilter = () => {
    const filters = {
      FromDate: fromDate,
      ToDate: toDate,
      VehicleNumber: vehicleNo || '', // Use vehicle ID
      DriverName: driverName || '', // Use driver ID    
      OwnerTypeId: selectedOwnerType || '',
      VehicleTypeId: selectedVehicleType || ''
    };
    fetchData(filters);
  };

  const fetchVehicleDetails = async () => {
    try {
      const VehicleNumberData = await AllVehicleDetails();
      setVehicleNumberDetails(VehicleNumberData);
    } catch (error) {
      console.error("Error fetching owner type data:", error);
    }
  };

  useEffect(() => {
    const filters = {
      FromDate: fromDate,
      ToDate: toDate,
    };
    fetchData(filters); // Fetch data on component mount
    fetchVehicleDetails(); // Fetch vehicle details
    fetchDriverDetails(); // Fetch driver details
  }, []);



  const fetchDriverDetails = async () => {
    try {
      const VehicleNumberData = await AllDriverDetails();
      setDriverNameDetails(VehicleNumberData);
    } catch (error) {
      console.error("Error fetching owner type data:", error);
    }
  };


  useEffect(() => {
    setOptionVehicleValues(VehicleNumberDetails.map(VehicleNumber => ({
      value: VehicleNumber.vehicleId,
      label: VehicleNumber.vehicleNumber,
    })));
  }, [VehicleNumberDetails]);

  useEffect(() => {
    setOptionDriverValues(driverNameDetails.map(driver => ({
      value: driver.driverId,
      label: driver.driverName,
    })));
  }, [driverNameDetails]);




  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const downloadAsExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tertiary Trip");

    const boldFont = { bold: true };

    // Get current date and time
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Tertiary Trip Report Generated on: ${formattedDate}, ${formattedTime}`;

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 8);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add Report Title
    worksheet.addRow(["", "", "Tertiary Trip Report", ""]);
    worksheet.mergeCells(2, 2, 2, 8);
    worksheet.getCell(2, 2).value = "Tertiary Trip Report";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Define table headers
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Vehicle Number",
      "Vehicle Type",
      "Vehicle Capacity",
      "Owner Type",
      "Driver Name",
      "Forward Start Location",
      "Forward End Location",
      "Forward Start Time",
      "Forward End Time",
      "Return Start Location",
      "Return End Location",
      "Return Start Time",
      "Return End Time",
      "Trip Number",
      "Forward Trip Distance (Kilometers)",
      "Return Trip Distance (Kilometers)",
      "Total Distance (Kilometers)",
      "Travel Duration (Minutes)",
    ]);

    // Apply styles to headers
    tableHeaderRow.eachCell((cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 20) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
          bgColor: { argb: "FFFFFFFF" },
        };
      }
    });

    // Initialize grand totals
    let totalTripNumber = 0;
    let totalForwardTripDistance = 0;
    let totalReturnTripDistance = 0;
    let totalDistance = 0;
    let totalTravelDuration = 0;

    // Loop through all rows
    rows.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.vehicleNumber?? "N/A",
        item.vehicleType?? "N/A",
        item.vehicleCapacity?? "N/A",
        item.ownerType?? "N/A",
        item.driverName?? "N/A",
        item.forwardStartLocation?? "N/A",
        item.forwardEndLocation?? "N/A",
        formatDateTimeWithoutSec(item.forwardStartTime)?? "N/A",
        formatDateTimeWithoutSec(item.forwardEndTime)?? "N/A",
        item.returnStartLocation?? "N/A",
        item.returnEndLocation?? "N/A",
        item.returnStartTime?? "N/A",
        item.returnEndTime?? "N/A",
        item.tripNumber?? "N/A",
        item.forwardTripDistanceMeters.toFixed(3) ?? "N/A",
        item.returnTripDistanceMeters.toFixed(3) ?? "N/A",
        item.totalDistanceMeters.toFixed(3) ?? "N/A",
        item.travelDurationMinutes?? "N/A",
      ]).eachCell((cell) => {
        cell.alignment = { horizontal: "left" };
      });

      // Accumulate grand totals
      totalTripNumber += item.tripNumber || 0;
      totalForwardTripDistance += item.forwardTripDistanceMeters || 0;
      totalReturnTripDistance += item.returnTripDistanceMeters || 0;
      totalDistance += item.totalDistanceMeters || 0;
      totalTravelDuration += item.travelDurationMinutes || 0;
    });

    // Add a single total row at the end
    const totalRow = worksheet.addRow([
      "Total",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "", // Total trip number
      totalTripNumber, // Total forward trip distance
      "", // Total return trip distance
      "",
      "", // Grand total distance
      totalTravelDuration, // Grand total travel duration
    ]);

    // Apply styles to total row
    totalRow.eachCell((cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFF00" }, // Yellow background for totals
        bgColor: { argb: "FFFFFFFF" },
      };
    });

    worksheet.columns = [
      { width: 5 }, { width: 20 }, { width: 20 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 20 }, { width: 25 }, { width: 20 }, { width: 25 }, { width: 20 },
      { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 },
      { width: 20 }, { width: 25 }, { width: 25 }, { width: 25 }
    ];
    // Save the workbook to a file
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "TertiaryTripReport.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };


  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">Tertiary Trip Report</h4>
            <div className="card">
                  <div className="card-body p-3">
                    <div className="row align-items-end text-start">
                    <div className="col-md-2">
                    <div>
                      <label className="form-label w-100 text-left">From Date</label>
                      <input
                      type="datetime-local"
                      id="FromDate"
                      name="FromDate"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      className="form-control"
                      max={toDate}
                    />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div>
                      <label className="form-label w-100 text-left">To Date</label>
                      <input
                        type="datetime-local"
                        id="ToDate"
                        name="ToDate"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        className="form-control"
                        min={fromDate}
                        max={currentDateTime}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="ownerType">Owner Type:</label>
                    <CreatableSelect style={{ Height: '34px !important' }}
                      classNamePrefix="CreatableSelect"
                      inputId="ownerType"
                      name="ownerTypeId"
                      id="ownerType"
                      placeholder="Select"
                      options={optionsValues}
                      isClearable={true}
                      onChange={handleChange}
                      onCreateOption={(inputValue) => {
                        const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                        { inputValue && newValue ? (setSelectedOwnerType(newValue.value)) : setSelectedOwnerType("  "); }
                        // setSelectedOwnerType(newValue.value);
                        // Add logic to update optionsValues with the new option if needed
                      }}
                      value={optionsValues.find((option) => option.value === selectedOwnerType)}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="VehicleType">Vehicle Type:</label>
                    <CreatableSelect style={{ Height: '34px !important' }}
                      classNamePrefix="CreatableSelect"
                      inputId="vehicleType"
                      name="vehicleTypeId"
                      id="vehicleType"
                      placeholder="Select"
                      options={vehicleTypeOptionsValues}
                      isClearable={true}
                      onChange={handleVehicleTypeChange}
                      onCreateOption={(inputValue) => {

                        const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                        { inputValue && newValue ? (setSelectedVehicleType(newValue.value)) : setSelectedVehicleType("  "); }
                        // setSelectedOwnerType(newValue.value);
                        // Add logic to update optionsValues with the new option if needed
                      }}
                      value={vehicleTypeOptionsValues.find((option) => option.value === selectedVehicleType)}
                    />
                  </div>
                  <div className="col-md-2">
                    <div className="">
                      <label>Vehicle Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={vehicleNo}
                        // id="vehicle-filter-input" 
                        placeholder='Enter Vehicle Number'
                        onChange={(e) => setVehicleNo(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="">
                      <label className="">Driver Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={driverName}
                        placeholder='Enter Driver Name'
                        onChange={(e) => setDriverName(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ marginRight: '30px' }}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className='d-flex justify-content-start align-items-end'>
                      <button variant="contained"
                        className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                        onClick={handleFilter} sx={{ padding: '10px 20px', marginTop: '5px' }}>
                        Search
                      </button>
                      <button
                        className="btn btn-excel ms-2"
                        onClick={downloadAsExcel}
                      >
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                      </button>
                    </div>
                  </div>
                  <div className='table-responsive'>
                    <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '20px' }}>
                      <TableContainer
                        component={Paper}
                        sx={{
                          width: '100%',
                          maxHeight: '500px',
                          border: '1px solid #ccc',
                        }}
                      >
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead
                            sx={{
                              position: 'sticky',
                              top: 0,
                              zIndex: 0, // Ensure header stays above other content
                            }}
                          >
                            <TableRow sx={{ paddingTop: '20px' }}>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>S.No</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Vehicle Number</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Vehicle Type</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Vehicle Capacity</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Owner Type</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Driver Name</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Forward Start Location</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Forward End Location</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Forward Start Time</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Forward End Time</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Return Start Location</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Return End Location</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Return Start Time</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Return End Time</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Trip Number</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Forward Trip Distance (Kilometers)</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Return Trip Distance (Kilometers)</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Total Distance (Kilometers)</TableCell>
                              <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#043555" : "#EC1117", }}>Travel Duration (Minutes)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.length > 0 ? (
                              rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => (
                                  <TableRow
                                    key={row.sno}
                                    sx={{
                                      backgroundColor: index % 2 === 1 ? 'rgba(4, 53, 85, 0.04)' : '#ffffff',
                                      '&:nth-of-type(odd)': { backgroundColor: '#ffffff' },
                                      '&:nth-of-type(even)': { backgroundColor: 'rgba(4, 53, 85, 0.04)' },
                                    }}
                                  >
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '0px' }}>{row.sno}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>{row.vehicleNumber || 'N/A'}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>{row.vehicleType || 'N/A'}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>{row.vehicleCapacity || 'N/A'}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>{row.ownerType || 'N/A'}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '0px' }}>{row.driverName || 'N/A'}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '0px' }}>{row.forwardStartLocation || 'N/A'}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>{row.forwardEndLocation || 'N/A'}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '0px' }}>
                                      {row?.forwardStartTime ? formatDateTimeWithoutSec(row?.forwardStartTime) : 'N/A'}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '0px' }}>
                                      {row?.forwardEndTime ? formatDateTimeWithoutSec(row?.forwardEndTime) : 'N/A'}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>{row.returnStartLocation || 'N/A'}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', }}>{row.returnEndLocation || 'N/A'}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>
                                      {row.returnStartTime || 'N/A'}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>
                                      {row.returnEndTime || 'N/A'}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '0px' }}>{row.tripNumber || 'N/A'}</TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>
                                      {row.forwardTripDistanceMeters === 0 ? 0 : row.forwardTripDistanceMeters.toFixed(3) || 'N/A'}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>
                                      {row.returnTripDistanceMeters === 0 ? 0 : row.returnTripDistanceMeters.toFixed(3) || 'N/A'}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px' }}>
                                      {row.totalDistanceMeters === 0 ? 0 : row.totalDistanceMeters.toFixed(3) || 'N/A'}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '0px' }}>{row.travelDurationMinutes ?? 'N/A'}</TableCell>
                                  </TableRow>
                                ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={20} sx={{ textAlign: 'center' }}>No data available</TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                          {rows.length > 0 && (
                            <TableFooter>
                              <TableRow sx={{ backgroundColor: 'rgb(255, 237, 238)', fontWeight: 'bold' }}>
                                <TableCell sx={{ textAlign: 'center', color: 'black' }} colSpan={14}>Total</TableCell>

                                {/* Show the total for only the visible rows on the current page */}
                                <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}>
                                  {rows
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) // Get only the current page rows
                                    .reduce((sum, row) => sum + (row.tripNumber || 0), 0)}
                                </TableCell>

                                <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}>  {rows.length > 0 ? "" : <>&nbsp;</>}</TableCell>
                                <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}>  {rows.length > 0 ? "" : <>&nbsp;</>}</TableCell>
                                <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}>  {rows.length > 0 ? "" : <>&nbsp;</>}</TableCell>

                                {/* Show travelDurationMinutes total for the current page */}
                                <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}>
                                  {rows
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) // Get only the current page rows
                                    .reduce((sum, row) => sum + (row.travelDurationMinutes || 0), 0)}
                                </TableCell>
                              </TableRow>
                            </TableFooter>
                          )}
                        </Table>
                      </TableContainer>
                      <TablePagination
                        component="div"
                        count={rows.length}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </Paper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TertiaryTripDetailsReport;